import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { get } from 'lodash';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import styled from 'styled-components';
import { BENEFICIARY, EMPTY_BENEFICIARY } from 'containers/data-structure';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import BeneficiaryForm from 'containers/PreOpeningPage/BeneficiaryForm';
import { Listings } from 'containers/AppContainer/typings';
import {
  ageValidation,
  getAgeBeneficiary,
} from 'containers/PreOpeningPage/utils';
import { VictimType, BeneficiaryType } from 'typings/globalTypes';

const Container = styled.div`
  .subContainer {
    padding: 20px;
    display: flex;
    flex-direction: column;
    width: 100% !important;
  }
  .text {
    font-size: 13px;
    color: #374065;
    letter-spacing: 0px;
    font-weight: medium;
    font-family: Roboto;
  }
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;

export interface BeneficiaryDrawerProps {
  intl: IntlShape;
  open: boolean;
  listing: Listings;
  handleSubmit: Function;
  handleToggleDrawer: Function;
  beneficiary: BeneficiaryType;
  victim: VictimType;
  isCourtMonitoringManagerUpdate?: boolean;
  setBeneficiaryToUpdate?: Function;
  beneficiaryToUpdate?: any;
  lossDate?: string;
  isCourtManager?: boolean;
}

const BeneficiaryDrawer: React.FC<BeneficiaryDrawerProps> = (
  props,
): JSX.Element => {
  let [beneficiary, setBeneficiary] = React.useState<BeneficiaryType>({
    ...EMPTY_BENEFICIARY,
    ...props.beneficiary,
  });

  const handleChange = (beneficiary: BeneficiaryType) => {
    setBeneficiary(beneficiary);
  };

  const handleValidation = () => {
    props.handleSubmit(beneficiary);
    props.setBeneficiaryToUpdate &&
      props.setBeneficiaryToUpdate({ ...beneficiary });
    props.handleToggleDrawer();
  };

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.beneficiaryAccordionTitle }, props, {
        number: null,
      })}
      handleValidateDrawer={handleValidation}
      confirmButtonTitle={translate(
        recapManagerMessages.drawerSaveFormButtonTitle,
        props,
      )}
      isSaveButtonDisabled={
        !get(beneficiary, [BENEFICIARY.DATE_OF_BIRTH]) ||
        get(beneficiary, [BENEFICIARY.DATE_OF_BIRTH]) === 'Invalid date' ||
        ageValidation(
          get(beneficiary, [BENEFICIARY.BENEFICIARY_TYPE], ''),
          getAgeBeneficiary(
            get(beneficiary, [BENEFICIARY.DATE_OF_BIRTH]) as any,
            props.lossDate,
            get(beneficiary, [BENEFICIARY.AGE]),
          ),
        )
      }
    >
      <Container>
        <BeneficiaryForm
          isDrawer={true}
          listing={props.listing}
          beneficiary={props.beneficiary}
          isCourtMonitoringManagerUpdate={props.isCourtMonitoringManagerUpdate}
          handleDrawerChange={handleChange}
          victim={props.victim}
          beneficiaryToUpdate={props.beneficiaryToUpdate}
          lossDate={props.lossDate}
        />
      </Container>
    </SahamDrawer>
  );
};

export default injectIntl(BeneficiaryDrawer);
